import React from "react";

const Team = () => {
  return (
    <div className="mb-10">
      <h3 className="text-themeColor font-popinsBold text-3xl md:text-4xl lg:text-5xl text-center mb-10 px-2">
        Behind every great product is a great team.
      </h3>
      <img src="/assets/our-team/myteam.png" alt="" />
    </div>
  );
};

export default Team;
